import {
  fetchSensitiveAttachmentCiphertext,
  getSensitiveAttachmentInfo,
} from '../api/attachmentsClient';
import {
  decryptSensitiveAttachmentBlob,
  decryptSensitiveAttachmentMetadata,
} from '../utils/crypto/sensitiveAttachmentCrypto';

export async function loadSensitiveAttachment({ attachmentId, kind, token, vaultKey }) {
  if (!vaultKey) throw new Error('Sensitive Vault is locked');
  const info = await getSensitiveAttachmentInfo(attachmentId, token);
  const privateMetadata = await decryptSensitiveAttachmentMetadata({
    entryId: info.entryId,
    metadata: info.sensitiveCrypto,
    vaultKey,
  });
  const ciphertextBlob = await fetchSensitiveAttachmentCiphertext(
    attachmentId,
    kind,
    token
  );
  const blob = await decryptSensitiveAttachmentBlob({
    entryId: info.entryId,
    metadata: info.sensitiveCrypto,
    kind,
    ciphertextBlob,
    vaultKey,
  });
  return { blob, privateMetadata, info };
}

export async function loadSensitiveAttachmentBlob(args) {
  const { blob } = await loadSensitiveAttachment(args);
  return blob;
}
